import GrComponentFactory from "../../gr_component_factory";
import GrPropTypes from "../../shared/gr_prop_types";
import SocialUpdate from "../social_update";
import SocialUpdateBody from "../social_update_body";
import UserFollowingDetails from "./user_following_details";
import UserIcon from "../../user/user_icon";
import { ICON_SIZES } from "../../../modules/shape_icon_values";

export default GrComponentFactory.createClass({
  displayName: "UserFollowingNewsfeedItem",


  propTypes: {
    resource: GrPropTypes.userFollowingNewsfeedResource(),
  },

  render() {
    const icon =  <UserIcon user={this.props.resource.followingUser} size={ICON_SIZES.LARGE}/>;
    const body = <SocialUpdateBody customIcon={icon}>
                 <UserFollowingDetails {...this.props.resource}/>
               </SocialUpdateBody>;

    return <SocialUpdate
      header={<span>is now following:</span>}
      body={body}
      {...this.props}
      />;
  },
});
